const metricsRoutes = [{
  path: "metrics",
  name: "Metrics",
  redirect: {
    name: "Collaborators Metric"
  },
  component: () =>
    import( /* webpackChunkName: "metrics" */ "../../views/metrics/Metrics.vue"),
  children: [{
      path: "collaborators",
      name: "Collaborators Metric",
      component: () =>
        import( /* webpackChunkName: "Collaborators Metric" */ "../../views/metrics/CollaboratorsMetric.vue")
    },

  ]
}];

export default metricsRoutes;
